import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getNotificationPreferencesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
const NOTIFICATION_PREFERENCES_BASE_URL = '/notification/preferences/v2';
export const _fetchNotificationPreferences = () => http.get(`${NOTIFICATION_PREFERENCES_BASE_URL}/preferences`, {
  query: {
    locale: 'en'
  }
});
export const getNotificationPreferences = () => getFromEarlyRequest(getNotificationPreferencesKey(), () => _fetchNotificationPreferences());